import React, { FC, useEffect, useRef } from 'react'
import './textfield.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


export type AutoCompleteTypes = 'off' | 'on' | 'given-name' | 'additional-name' | 'family-name' | 'email' | 'username' | 'new-password' | 'current-password' |
    'one-time-code' | 'street-address' | 'address-line1' | 'address-line2' | 'country' | 'postal-code' | 'cc-name' | 'tel' | 'tel-national' | 'organization' | 'url' |
    'cc-exp' | 'bday' | 'bday-day' | 'bday-month' | 'bday-year' | 'billing' | 'cc-name'

type TextFieldTypes = 'email' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'url' | 'date'

interface Props extends Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<Partial<HTMLInputElement>>, HTMLInputElement>, 'type'> {
    autoComplete?: AutoCompleteTypes
    name?: string,
    focus?: boolean,
    invalid?: boolean
    inlineElementLeft?: JSX.Element
    divideElementLeft?: boolean
    inlineElementRight?: JSX.Element
    divideElementRight?: boolean
    integratedLabel?: JSX.Element
    type?: TextFieldTypes
}

const TextField: FC<Props> = (props) => {
    const { className: classProps, name = 'textfield', focus, invalid, inlineElementLeft, divideElementLeft, inlineElementRight, divideElementRight, integratedLabel, autoComplete = 'on', ...inputProps } = props
    const className = flatten("textfield", { invalid }, classProps)
    const inputRef = useRef<any>(null)

    useEffect(() => {
        if (focus) inputRef.current.focus();
    }, [focus])

    // RENDER FUNCTIONS
    function createInput(): JSX.Element {
        return (
            <div className="textfield-container">
                {createIntegratedLabel()}
                {createInlineElementLeft()}
                <input className="content" name={name} ref={inputRef} autoComplete={autoComplete} {...inputProps} />
                {createInlineElementRight()}
            </div>
        )
    }

    function createInlineElementLeft(): JSX.Element | undefined {
        return !inlineElementLeft ? undefined : (<>
            <div className="inline-element left">
                {inlineElementLeft}
            </div>
            {divideElementLeft && <div className="divider" />}
        </>)
    }

    function createInlineElementRight(): JSX.Element | undefined {
        return !inlineElementRight ? undefined : (<>
            {divideElementRight && <div className="divider" />}
            <div className="inline-element right">
                {inlineElementRight}
            </div>
        </>)
    }

    function createIntegratedLabel(): JSX.Element | undefined {
        return !integratedLabel ? undefined : (<>
            <div className="integrated-label">
                {integratedLabel}
            </div>
        </>)
    }

    return (<>
        <div className={className}>
            {createInput()}
        </div>
    </>)
}

export default TextField
